import { Component, Input, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { PolicyFormVersion } from "@app/definitions/types"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { SafeHtmlPipe } from "@app/utils/safe-html.pipe"
import { BtnExtComponent } from "@app/utils/utils.component"
import { Version } from "./version.component"

@Component({
	selector: "row",
	imports: [
		COMMON_IMPORTS,
		DateFormatPipe,
		SafeHtmlPipe,
		BtnExtComponent,
		ModalWrapComponent,
		Version,
	],
	template: `
		<tr>
			<td>{{ actObject.created_at | dateFormat }}</td>
			<td [innerHTML]="actObject.description | safeHtml"></td>
			<td>
				@if (canOpen) {
					<app-btn-ext
						[text]="disabled ? 'see_document' : 'edit'"
						(clickEv)="isOpen = !isOpen"
					/>
				}
			</td>
		</tr>
		@if (isOpen) {
			<app-modal-wrap
				(onClose)="isOpen = false"
				title="edit"
				modalWrapperClass="modal-750"
			>
				<version
					(onClose)="isOpen = false"
					[disabled]="disabled"
					[actObject]="actObject"
				/>
			</app-modal-wrap>
		}
	`,
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: `
		:host {
			display: contents;
		}
	`,
})
export class Row {
	@Input() actObject: PolicyFormVersion
	@Input() disabled: boolean
	@Input() canOpen: boolean
	isOpen: boolean = false
}
